/* index.tsx generated by @compiled/babel-plugin v0.29.1 */
import "./index.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { useRouterActions } from 'react-resource-router';
import Button from '@atlaskit/button';
import { DynamicTableStateless } from '@atlaskit/dynamic-table';
import { media } from '@atlaskit/primitives/responsive';
import { FireUIAnalytics } from '@atlassian/analytics-bridge';
import { usePfErrorUtils } from '@atlassian/proforma-common-core/jira-common-context';
import { TicketType } from '@atlassian/proforma-common-core/jira-common-models';
import { Action, ActionSubject } from '@atlassian/proforma-utils/analytics';
import { extractTicketTypeId } from '../../../../common/utils/ticket-types';
import { useProjectFormsController } from '../../../../controllers';
import { useRequestTypeCategories } from '../../../../controllers/use-request-type-categories';
import { ExportContainer } from '../../../../services/export';
import { useIssueFormsApi } from '../../../../services/issue-forms-api';
import { useProjectFormApi } from '../../../../services/project-form-api';
import { FormActions } from './form-actions';
import { messages } from './messages';
import { RequestTypes } from './request-types';
import { FormNameWrapper } from './styled';
var ProjectFormColumns = /*#__PURE__*/function (ProjectFormColumns) {
  ProjectFormColumns["Actions"] = "Actions";
  ProjectFormColumns["AssociatedTypes"] = "AssociatedTypes";
  ProjectFormColumns["Name"] = "Name";
  ProjectFormColumns["Updated"] = "Updated";
  return ProjectFormColumns;
}(ProjectFormColumns || {});
export const Table = ({
  projectKey,
  projectType,
  userIsProjectAdmin,
  searchTextFilter,
  simplifiedProject,
  filteredTypeIds
}) => {
  const isServiceProject = projectType === 'service_desk';
  const errorUtils = usePfErrorUtils();
  const projectFormApi = useProjectFormApi();
  const issueFormsApi = useIssueFormsApi();
  const [{
    forms,
    loading,
    sortKey,
    sortOrder
  }, {
    onSort
  }] = useProjectFormsController();
  const requestTypeCategories = useRequestTypeCategories({
    isServiceCMP: isServiceProject && !simplifiedProject
  });
  const {
    push
  } = useRouterActions();
  const [issueFormsInfo, setIssueFormsInfo] = useState(undefined);
  useEffect(() => {
    issueFormsApi.getIssueFormsInfo().then(res => {
      setIssueFormsInfo(res);
    });
  }, [issueFormsApi]);
  const headers = [{
    key: ProjectFormColumns.Name,
    content: /*#__PURE__*/React.createElement(FormattedMessage, messages.nameColumnHeader),
    isSortable: false,
    width: 8
  }, {
    key: ProjectFormColumns.AssociatedTypes,
    content: /*#__PURE__*/React.createElement(FormattedMessage, isServiceProject ? messages.requestTypesColumnHeader : messages.issueTypesColumnHeader),
    isSortable: false,
    width: 5
  }, {
    key: ProjectFormColumns.Updated,
    content: /*#__PURE__*/React.createElement(FormattedMessage, messages.lastUpdatedColumnHeader),
    isSortable: true,
    width: 3
  }, {
    key: ProjectFormColumns.Actions,
    content: /*#__PURE__*/React.createElement(React.Fragment, null),
    isSortable: false,
    width: 1
  }].filter(Boolean);
  const [rows, setRows] = useState([]);
  useEffect(() => {
    const typeFilter = isServiceProject ? t => t.type === TicketType.RequestType : t => t.type === TicketType.IssueType;
    const formFilter = form => form.name.toLowerCase().includes(searchTextFilter.toLowerCase()) && (filteredTypeIds.length === 0 || form.requesttypes.filter(typeFilter).some(requestType => filteredTypeIds.length === 0 || filteredTypeIds.includes(extractTicketTypeId(requestType.id))));
    setRows(forms.filter(formFilter).map(form => {
      const requestTypes = form.requesttypes.filter(typeFilter);
      return {
        key: `row-${form.projectId}-${form.id}`,
        cells: [{
          key: `${form.name}-${form.id}`,
          content: /*#__PURE__*/React.createElement(Button, {
            appearance: "subtle-link",
            onClick: () => push(form.editUrl),
            style: {
              // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
              display: 'flex',
              // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
              alignItems: 'center',
              // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
              height: 'fit-content'
            }
          }, /*#__PURE__*/React.createElement(FormNameWrapper, {
            id: `${form.name.replace(/\s+/g, '')}-${form.id}`
          }, form.name || /*#__PURE__*/React.createElement(FormattedMessage, messages.emptyFormName)))
        }, {
          key: ProjectFormColumns.AssociatedTypes,
          content: /*#__PURE__*/React.createElement(RequestTypes, {
            projectKey: projectKey,
            simplifiedProject: simplifiedProject,
            isServiceProject: isServiceProject,
            requestTypes: requestTypes,
            requestTypeCategories: requestTypeCategories
          })
        }, {
          key: `${ProjectFormColumns.Updated}-${form.updated.iso8601}-${form.id}`,
          content: form.updated.friendly
        }, {
          key: `${ProjectFormColumns.Actions}-${form.id}`,
          content: /*#__PURE__*/React.createElement(FormActions, {
            projectType: projectType,
            simplifiedProject: simplifiedProject,
            userIsProjectAdmin: userIsProjectAdmin,
            form: form,
            projectKey: projectKey,
            issueFormsInfo: issueFormsInfo
          })
        }].filter(Boolean)
      };
    }));
  }, [filteredTypeIds, forms, isServiceProject, projectType, push, searchTextFilter, userIsProjectAdmin, projectKey, simplifiedProject, requestTypeCategories, issueFormsInfo]);
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_1reo1wug"])
  }, /*#__PURE__*/React.createElement("div", {
    className: ax(["_1bsb1c3h _g7111wug"])
  }, /*#__PURE__*/React.createElement(ExportContainer, {
    errorUtils: errorUtils,
    projectFormApi: projectFormApi
  }, /*#__PURE__*/React.createElement(DynamicTableStateless, {
    head: {
      cells: headers
    },
    rows: rows,
    loadingSpinnerSize: "large",
    isLoading: loading,
    isFixedSize: true,
    sortKey: sortKey,
    sortOrder: sortOrder,
    onSort: onSort
  })), !loading && /*#__PURE__*/React.createElement(FireUIAnalytics, {
    actionSubject: ActionSubject.TABLE,
    action: Action.VIEWED,
    actionSubjectId: "proformaDynamicTable",
    attributes: {
      tableRowsCount: rows.length,
      tableSortKey: sortKey,
      tableSortOrder: sortOrder
    }
  })));
};
const WrapperContainer = null;
const OverflowContainer = null;